import {SubscriptionSvc, UPDATE_SUBSCRIPTION_CARD} from '../../services/SubscriptionSvc';

class SubscriptionPaymentDetailsContainer implements ng.IComponentController {
    onChange: () => void;
    loadingDetails: boolean;
    isStripe = () => this.subscriptionSvc.isStripe();
    cardDetails: anm.CardDetails;
    private cardUpdateListener: Function = _.noop;


    constructor(private $rootScope: ng.IRootScopeService,
                private subscriptionSvc: SubscriptionSvc) {
        this.cardUpdateListener = this.$rootScope.$on(UPDATE_SUBSCRIPTION_CARD, () => this.setCardDetails());
    }

    $onDestroy() {
        this.cardUpdateListener();
    }

    private setCardDetails() {
        this.loadingDetails = true;
        return this.subscriptionSvc.getCardDetails()
            .then((response: anm.CardDetails) => {
                this.cardDetails = response;
            })
            .finally(() => {
                this.loadingDetails = false;
            });
    }
}

angular.module('animatronApp.SubscriptionPaymentDetailsContainer', [])
    .component('subscriptionPaymentDetailsContainer', {
        bindings: {
            loadingDetails: '<',
            cardDetails: '<',
            onChange: '&?'
        },
        controller: SubscriptionPaymentDetailsContainer,
        templateUrl: require('settings/subscription/containers/subscription-payment-details-container.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/containers/SubscriptionPaymentDetailsContainer.ts